import { Component, type ErrorInfo, type ReactNode } from 'react'

/**
 * Last line of defence for a rendering crash. Without it, a thrown error unmounts the entire
 * React tree and the user stares at a blank page; with it, they get a styled explanation and
 * a reload button. State-free by design — reloading is the only safe recovery.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false }

  static getDerivedStateFromError() {
    return { crashed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled rendering error:', error, info.componentStack)
  }

  render() {
    if (!this.state.crashed) return this.props.children

    return (
      <div className="signin">
        <div className="signin-card panel">
          <div className="sb-brand" style={{ padding: 0, marginBottom: 22 }}>
            <span className="mark">
              <span style={{ background: '#EF5974' }} />
              <span style={{ background: '#28A0DD' }} />
              <span style={{ background: '#C8D44B' }} />
            </span>
            <span>
              <span className="nm" style={{ color: 'var(--navy)' }}>
                Burendo
              </span>
              <span className="sub" style={{ color: 'var(--slate)' }}>
                Opportunity Intelligence
              </span>
            </span>
          </div>

          <div className="eyebrow">Application error</div>
          <h1 className="disp" style={{ fontSize: 28, margin: '8px 0' }}>
            Something went wrong
          </h1>
          <p className="lede" style={{ fontSize: 14.5, marginBottom: 24 }}>
            The app hit an unexpected problem and couldn&rsquo;t recover. Reloading the page
            almost always fixes it — your briefs and research are safely stored.
          </p>
          <button
            className="genbtn"
            style={{ margin: 0, width: '100%', justifyContent: 'center' }}
            onClick={() => window.location.reload()}
          >
            <i className="ti ti-refresh" style={{ fontSize: 17 }} /> Reload the app
          </button>
        </div>
      </div>
    )
  }
}
